import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { glossaryKeys } from '@/shared/lib/query/queryKeys';

import { createGlossaryCategoryApi } from '@/features/glossary/api';
import type { CreateGlossaryCategoryRequest } from '@/features/glossary/api';

export const useCreateGlossaryCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateGlossaryCategoryRequest) => createGlossaryCategoryApi(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: glossaryKeys.all });
      queryClient.invalidateQueries({ queryKey: glossaryKeys.glossaryTree });
      queryClient.invalidateQueries({ queryKey: glossaryKeys.categoriesAll() });

      notification.success({
        message: NOTIFICATION_MESSAGES.GLOSSARY_CATEGORY_CREATE_SUCCESS,
        placement: 'bottomLeft',
        duration: 3,
      });
    },
  });
};
